import { atomWithStorage } from "jotai/utils";

export const profileAtom = atomWithStorage("WOG_profile_data", []);
